const initialState = {
    
    data: {},
    list: [],

    error: null,
    loading: false,
    lastUpdate: null
};

export default function unplannedRoutes(state = initialState, action) {

    switch (action.type) {

        case 'UNPLANNED_ROUTES_REQUEST':

            return Object.assign({}, state, {
                data: {},
                list: [],
                error: null,
                loading: true
            });

        case 'UNPLANNED_ROUTES_SUCCESS':

            var { lastUpdate } = action;
            var { data=[] } = action.data || {};

            var route_data = {};
            var route_list = [];

            data.forEach((item) => {
                route_data[item.documentId] = {...item};
                route_list.push(item.documentId);
            });

            return Object.assign({}, state, {
                data: route_data,
                list: route_list,
                error: null,
                loading: false,
                lastUpdate: lastUpdate
            });

        case 'UNPLANNED_ROUTES_ERROR':

            var { error } = action;

            return Object.assign({}, state, {
                error: error,
                loading: false
            });

        
        case 'UNPLANNED_ROUTE_ADD':

            var { data={} } = action.data || {};
            
            var route_data = {
                ...state.data,
                [data.documentId]: data
            }

            var route_list = [
                ...state.list,
                data.documentId
            ];

            return Object.assign({}, state, {
                data: route_data,
                list: route_list
            });
        
        case 'UNPLANNED_ROUTE_UPDATE':

            var { data={} } = action.data || {};
            
            var route_data = {
                ...state.data
            }

            if (route_data[data.documentId]) {
                route_data[data.documentId] = {
                    ...state.data[data.documentId],
                    ...data
                }
            }

            return Object.assign({}, state, {
                data: route_data
            });


        default:
            return state;
    }
    
}
